import { Navbar } from 'react-daisyui';

import { MessageScreen } from '@/components/MessageScreen';

function EndService() {
  return (
    <>
      <Navbar className="fixed top-0 z-50 border-b border-[#85B50F] min-h-12 bg-[#85B50F] text-white w-full max-w-md">
        <div className="justify-center flex-1 text-center">
          <label className="text-base font-bold">サービス終了のご案内</label>
        </div>
      </Navbar>
      <MessageScreen
        iconType="info"
        message={
          <>
            <p className="font-bold">「harmoおくすり手帳」は2026年9月30日をもってサービスを終了しました。</p>
            <p>これまでご利用いただき、誠にありがとうございました。</p>
            <p>後継サービスの「お薬手帳3.0」へ移行をご希望の場合は、アプリに戻って移行を進めてください。</p>
          </>
        }
        buttonTitle="閉じる"
        onClick={() => window.close()}
      />
    </>
  );
}

export default EndService;
